export default function ScoreIcon({ value = 0 }) {
  let iconClass = '';
  let color = '';

  if (value < 33.3) {
    iconClass = 'bi bi-exclamation-triangle-fill';
    color = '#ef4444'; // red
  } else if (value < 66.6) {
    iconClass = 'bi bi-exclamation-circle-fill';
    color = '#f59e0b'; // orange
  } else {
    iconClass = 'bi bi-shield-fill-check';
    color = '#22c55e'; // green
  }

  return <i className={iconClass} style={{ fontSize: '16px', color }}></i>;
}
